import React, { useEffect, useState } from 'react';
import { Button, Modal} from 'react-bootstrap';
import { useParams } from "react-router-dom";
import { useAuth } from '../../../../Auth';
import { useTranslate } from 'react-polyglot';
import PageTable from '../../../Shared/PageTable/PageTable';
import { useAxios } from '../../../../AxiosHandler';

import _ from 'lodash';

import moment from 'moment';
import Field from '../../../Shared/Wizard/Field/Field';
import { toast } from 'react-toastify';

interface invoiceRow {
    id: string,
    price: string,
    amount: number,
    firstname: string,
    lastname: string,
    note: string,
    internat: string,
    invo_id: number
}

function EventInvoicing(props) {
    let { id } = useParams();
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const localStorageUser = localStorage.getItem("user");
    let settings;
    if (localStorageUser != null) {
        settings = JSON.parse(localStorageUser)["settings"];
    }

    const [kaAssistInvoicerows, setKAAssistInvoicerows] = useState<Array<any>>([]);
    const [showKAAssistModal, setShowKAAssistModal] = useState(false);

    const [loading, setLoading] = useState(true);
    
    function ResourcesToPricegroups(booking, resources) {
        let tmpResources = resources.map(resource=> {
            return {
                keyType: resource["resourceType"],
                keySubtype: resource["resourceSubtype"],
                resource: resource["resource"],
                price: resource["overridePrice"] != undefined ? resource["overridePrice"] : resource["price"],
                unit: resource["unit"],
                amount: sumOfAmount(booking, resource["resource"]).reduce(((accumulator, currentValue) => Number(accumulator) + Number(currentValue)), []),
            } 
        });

        let groups:Array<any> = [];
        tmpResources.forEach(resource => {
            if (groups.some(g => g["keyType"] == resource["keyType"] && g["keySubtype"] == resource["keySubtype"])) {
                let group = groups.find(g => g["keyType"] == resource["keyType"] && g["keySubtype"] == resource["keySubtype"]);
                group.items.push(resource);
            } else {
                groups.push({ keyType: resource["keyType"], keySubtype: resource["keySubtype"], items: [resource] });
            }
        });

        return groups;
    }

    function sumOfAmount(booking, resource){
        let bookingAmount: Array<any> = [];
        let foundResource = props.allResources.find(r=> r._id == resource);
        let bookingResource = booking.resources.find(r => r.resource == resource);
        let resourceUnit = bookingResource != undefined ? bookingResource.unit : "";
        if (foundResource != undefined && foundResource.bookings != undefined) { 
            foundResource.bookings.forEach(rbooking => {
                if (rbooking.bookingtimes != undefined && rbooking.bookingId == booking._id) {
                    let isSpecific = false;
                    
                    for (let bookingtime of rbooking.bookingtimes) {
                        if (bookingtime.people != undefined && bookingtime.people.some(p => booking.guests.map(g => g._id).includes(p))) {
                            isSpecific = true;
                        }
                    }

                    rbooking.bookingtimes.forEach(item => {
                        if (isSpecific) {
                            if (item.people != undefined && item.people.some(p => booking.guests.map(g => g._id).includes(p))) {
                                let tmpAmount = calculateNumberOfAmount( item.start, item.end, resourceUnit);
                                bookingAmount.push(tmpAmount);
                            }
                        } else {
                            let tmpAmount = calculateNumberOfAmount( item.start, item.end, resourceUnit);
                            bookingAmount.push(tmpAmount);
                        }
                    });
                }
            });
        }
        return bookingAmount;
    }

    const calculateNumberOfAmount = (from, to, unit) =>{
        if(
            from != null &&
            from != undefined &&
            from != "" &&
            to != null &&
            to != undefined &&
            to != ""
        ){
            let timeDiff;

            if(unit == "once"){
                timeDiff = 1;
            } else {
                let tmpArrival = moment(from);
                let tmpDeparture = moment(to);
                let tmpUnit:any = unit+"s";
                if (unit == "day" || unit == "month" || unit == "week") {
                    tmpArrival = tmpArrival.startOf("day");
                    tmpDeparture = tmpDeparture.startOf("day");
                }
                timeDiff = tmpDeparture.diff(tmpArrival, tmpUnit);
                //Math.abs(tmpDeparture.getTime() - tmpArrival.getTime());
                //return Math.ceil(timeDiff / (1000 * 3600 * 24));                 
            }
            return timeDiff ;
        } else {
            return 0;
        }
    }

    const handleShowKAAssistModal = async () => {
        setShowKAAssistModal(true);
        setLoading(true);

        let eventBookings = props.allBookings.filter(b => b.events?.map(e => e._id).includes(id));

        let tmpInvoicerows: Array<any> = [];

        for (const booking of eventBookings) {
            await axios.single({
                method: "get",
                url: "/api/kaassist/" + booking._id,
                data: {},
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }).then(response => {
                if (response.status === 200) {
                    let pricegroups = ResourcesToPricegroups(booking, booking.resources);

                    if (response.data.length > 0) {
                        tmpInvoicerows.push({ bookingId: booking._id, data: response.data});
                    }
                }
            }).catch(err => {
                console.log(err);
            });
        }
        setLoading(false);

        setKAAssistInvoicerows(JSON.parse(JSON.stringify(tmpInvoicerows)));
    }
    
    async function handleExportKAAssist(){
        notifySuccess(t("event.invoicing.exportassist.starting"));

        for (const booking of kaAssistInvoicerows) {
            await axios.single({
                method: "post",
                url: "/api/kaassist/",
                responseType: "json",
                data: {
                    data: booking.data
                },
                headers: {'x-access-token': auth.user["token"]}
            }).then(res => {
                //console.log(res);
            }).catch(err => {
                console.log(err);
            });
        }

        notifySuccess(t("event.invoicing.exportassist.success"));

        setKAAssistInvoicerows([]);
        setShowKAAssistModal(false);
    }

    return (
        <div style={{ marginTop: '20px' }}>
            <div className="Events-container">
                <h4 className="header-title">{t("event.invoicing.title")}</h4>
                {auth.user["userdata"]["orgRole"][0] != "janitor" ?
                    <Button onClick={() => handleShowKAAssistModal()} className="no-print" style={{marginRight: "20px"}}>{t("booking.billing.kaassist.startbtn")}</Button>
                : null}
                <div className="pricetables">
                    { props.allBookings.filter(b => b.events?.map(e => e._id).includes(id))?.map((booking, bookingkey) => {
                        let pricegroups: any = [];
                        if (booking != undefined) {
                            pricegroups = ResourcesToPricegroups(booking, booking.resources)
                        }
                        
                        return <div key={bookingkey}>
                            { pricegroups.length > 0 ?
                                <React.Fragment>
                                    <hr/>
                                    <h4>{props.allCustomers.find(c => c._id == booking.customerId)?.organizationName ?? "Customer not found!"}</h4>
                                </React.Fragment>
                            : null}
                            { pricegroups.map((item, itemKey) =>
                                <table key={itemKey} style={{width: "100%"}} className="table table-striped table-bordered invoicetable">
                                    <thead>
                                        <tr>
                                            <th>{(((props.allResourceTypes.find(i => i["_id"] == item["keyType"]) || { name: "" }) as any)["name"]) + "/" + (item["keySubtype"])}</th>
                                            <th>{t("booking.billing.unit")}</th>
                                            <th>{t("booking.billing.amount")}</th>
                                            <th>{t("booking.billing.unitprice")}</th>
                                            <th>{t("booking.billing.sumofrow")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {item.items.map((i,key) => 
                                            <tr key={key}>
                                                <td>{(((props.allResources.find(resource => resource["_id"] == i["resource"]) || { name: "" }) as any)["name"])}</td>
                                                <td style={{width: "100px"}}>{t("general.unit.unittype." + i["unit"])}</td>
                                                <td style={{width: "100px"}}>{i["amount"].length != 0 ? i["amount"] : "N/A"}</td>
                                                <td style={{width: "100px"}}>{i["amount"].length != 0 ? (Number(i["overridePrice"] != undefined ? i["overridePrice"] : i["price"])) : 0}</td>
                                                <td style={{width: "100px"}}>{i["amount"].length != 0 ? (Number(i["overridePrice"] != undefined ? i["overridePrice"] * i["amount"] : i["price"] * i["amount"])) : 0}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table> 
                            )}
                        </div>
                    }) ?? null}
                </div>
            </div>
            {/* Export KAAssist modal */}
            <Modal show={showKAAssistModal} size="xl" onHide={() => setShowKAAssistModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("booking.billing.kaassist.title")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t("booking.billing.kaassist.exportmodal_info")}</p>
                    {loading ?
                        <>
                            <hr/>
                            <p>{t("booking.billing.kaassist.exportmodal_loading")}</p>
                        </>
                    : null}
                    { _.sortBy(kaAssistInvoicerows, [function(o) { return o.bookingId; }]).map((booking, bkey) => {
                        return <table key={bkey} className="invoicerowtable table table-sm table-striped">
                            <thead>
                                <tr>
                                    <th>{t("booking.billing.kaassist.exportmodal_table_invoid")}</th>
                                    <th>{t("booking.billing.kaassist.exportmodal_table_name")}</th>
                                    <th>{t("booking.billing.kaassist.exportmodal_table_note")}</th>
                                    <th>{t("booking.billing.kaassist.exportmodal_table_internat")}</th>
                                    <th>{t("booking.billing.kaassist.exportmodal_table_days")}</th>
                                    <th>{t("booking.billing.kaassist.exportmodal_table_price")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                { booking.data.map((row, key) => {
                                    return <tr key={key} className="invoicerow">
                                        <td style={{padding: "0px 10px"}}>
                                            <Field
                                                type="input"
                                                value={row.invo_id == undefined || row.invo_id == "" ? "Kan ikke eksporteres" : row.invo_id}
                                                disabled={row.invo_id == undefined || row.invo_id == ""}
                                                onChange={(val) => {
                                                    const newKaAssistInvoicerows = booking.data.map((r, rownum) => {
                                                        if (key == rownum) {
                                                            return {
                                                                ...r,
                                                                invo_id: val
                                                            }
                                                        }
                                                        return r;
                                                    });
                                                    setKAAssistInvoicerows([...kaAssistInvoicerows.filter(i => i.bookingId != booking.bookingId), { bookingId: booking.bookingId, data: newKaAssistInvoicerows } ]);
                                                }}
                                            ></Field>
                                        </td>
                                        <td style={{padding: "0px 10px"}}>{row.lastname + ", " + row.firstname}</td>
                                        <td style={{padding: "0px 10px"}}>{row.note}</td>
                                        <td style={{padding: "0px 10px"}}>
                                            <Field
                                                type="input"
                                                value={row.internat}
                                                onChange={(val) => {
                                                    const newKaAssistInvoicerows = booking.data.map((r, rownum) => {
                                                        if (key == rownum) {
                                                            return {
                                                                ...r,
                                                                internat: val
                                                            }
                                                        }
                                                        return r;
                                                    });
                                                    setKAAssistInvoicerows([...kaAssistInvoicerows.filter(i => i.bookingId != booking.bookingId), { bookingId: booking.bookingId, data: newKaAssistInvoicerows } ]);
                                                }}
                                            ></Field>
                                        </td>
                                        <td style={{padding: "0px 10px"}}>
                                            <Field
                                                type="input"
                                                value={row.amount}
                                                onChange={(val) => {
                                                    const newKaAssistInvoicerows = booking.data.map((r, rownum) => {
                                                        if (key == rownum) {
                                                            return {
                                                                ...r,
                                                                amount: val
                                                            }
                                                        }
                                                        return r;
                                                    });
                                                    setKAAssistInvoicerows([...kaAssistInvoicerows.filter(i => i.bookingId != booking.bookingId), { bookingId: booking.bookingId, data: newKaAssistInvoicerows } ]);
                                                }}
                                            ></Field>
                                        </td>
                                        <td style={{padding: "0px 10px"}}>
                                            <Field
                                                type="input"
                                                value={row.price}
                                                onChange={(val) => {
                                                    const newKaAssistInvoicerows = booking.data.map((r, rownum) => {
                                                        if (key == rownum) {
                                                            return {
                                                                ...r,
                                                                price: val
                                                            }
                                                        }
                                                        return r;
                                                    });
                                                    setKAAssistInvoicerows([...kaAssistInvoicerows.filter(i => i.bookingId != booking.bookingId), { bookingId: booking.bookingId, data: newKaAssistInvoicerows } ]);
                                                }}
                                            ></Field>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>;
                    })}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => {
                        setShowKAAssistModal(false);
                        setKAAssistInvoicerows([]);
                    }}>{t("booking.billing.kaassist.cancelbtn")}</Button>
                    <Button onClick={() => handleExportKAAssist()}> {t("booking.billing.kaassist.sendbtn")}</Button>
                </Modal.Footer>
            </Modal>
         </div>
    );
}


export default EventInvoicing;